module.exports = __webpack_public_path__ + "static/media/star.699178e6.svg";